<template>
  <div id="app">
    <router-view />
    <!-- <Email /> -->
    <MessagePopup ref="messagePopup" />
  </div>
</template>

<script>
import Email from '@/components/Email.vue'
import MessagePopup from '@/components/MessagePopup.vue'

export default {
  name: 'App',
  components: {
    Email,
    MessagePopup
  },
  mounted() {
    window.addEventListener('app-message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('app-message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      const detail = event && event.detail ? event.detail : {}
      if (this.$refs.messagePopup && this.$refs.messagePopup.show) {
        this.$refs.messagePopup.show(detail)
      }
    }
  }
}
</script>

<style>
@import '~@/assets/css/font.css';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  font-size: 1px;
}


@media (max-width: 768px) {
  html {
    font-size: calc(100vw / 375);
  }
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>